<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Enterprise Dashboard</h6>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <!-- <base-button size="sm" type="neutral" v-b-modal.new-business>New Business</base-button> -->
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col md="4" v-if="enterprises" v-for="enterprise in enterprises" :key="enterprise.id">
          <b-card
            overlay
            :img-src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + enterprise.logo"
            :img-alt="enterprise.name"
            body-class="d-flex flex-column">
              <h2 class="text-white text-center">{{ enterprise.name }}</h2>
              <b-button block :to="toRoute + enterprise.slug" variant="white" class="mt-auto">View</b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <new-business-modal></new-business-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import errorsMixin from '@/mixins/errors-mixin.js';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import NewBusinessModal from '@/views/Components/Modals/NewBusinessModal';

export default {
  mixins: [errorsMixin],
  components: {
    NewBusinessModal
  },
  data() {
    return {
      enterprises: [],
      file: []
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      observedRoute: 'observed/observedRoute'
    }),
    getRoute() {
      return this.$route.params.user ? this.observedRoute : this.userRoute;
    },
    toRoute() {
      return this.$route.params.user ? '/observatory/' + this.$route.params.user + '/enterprise/' : '/enterprise/';
    }
  },
  methods: {
    async getEnterprises() {
      await axios.get(this.getRoute + "/enterprises")
      .then(response => {
        this.enterprises = response.data;
      })
      .catch(error => {
        this.$router.push("/");
      });
    }
  },
  created() {
    this.getEnterprises();
  },
  mounted() {
    document.title = 'Enterprise | ClarityNOW';
  },
};
</script>